module.exports = __webpack_public_path__ + "img/box3_img4_light.d46079c6.png";